var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"text-nowrap",attrs:{"disabled":_vm.row.Paid},model:{value:(_vm.row.TMSVault),callback:function ($$v) {_vm.$set(_vm.row, "TMSVault", $$v)},expression:"row.TMSVault"}},[_vm._v("TMS Kasadan Öde")])}
var staticRenderFns = []

export { render, staticRenderFns }